export default __webpack_public_path__ + "static/media/army_53.1614a581.jpg";